import React from 'react';
import PropTypes from 'prop-types';
import {BASE_URL, SHORT_DATE_FORMAT} from "../../constants";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import {apiRequest} from "../../utils/request";
import moment from 'moment';


const hasRole = (user, role) => {
  if(!user){
    return false;
  }
  if(user.hasOwnProperty('hasRole')){
    return user.hasRole(role);
  }
  return user.roles.findIndex(x => x.roleName === role) >= 0;
};

const UserCols = (props, state) => [
  {
    id: 'contactName',
    Header: 'Name',
    accessor: c => c.contactName,
    Cell: row => (<div style={{textAlign: 'center'}}><a href="#" onClick={(e) => {
      e.preventDefault();
      props.onSelectUser(`${BASE_URL}/manage/users/${row.original.userId}`);
    }}>{row.value}</a></div>),
  },
  {
    id: 'isActive',
    Header: 'Active',
    accessor: c => c.isActive,
    Cell: row => (<div style={{textAlign: 'center'}}>{row.value ? <i className={'fa fa-check'} /> : <i className={'fa fa-times'} />}</div>),
  },
  {
    id: 'isLockedOut',
    Header: 'Locked',
    accessor: c => c.isLockedOut,
    Cell: row => (<div style={{textAlign: 'center'}}>{row.value ? <i className={'fa fa-check'} /> : <i className={'fa fa-times'} />}</div>),
  },
  {
    id: 'lastLoginDate',
    Header: 'Last Login',
    accessor: c => moment(c.lastLoginDate).format(SHORT_DATE_FORMAT),
    Cell: row => (<div style={{textAlign: 'center'}}>{row.value}</div>),
  },
];


class UsersByClientLocationControl extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      users: [],
      loading: true,
    };
    this.loadUsers = this.loadUsers.bind(this);
  }

  componentDidMount(){
    this.loadUsers();
  }

  loadUsers() {
    let {mode, clientId, locationId} = this.props;

    this.setState({loading: true});
    apiRequest(`/api/users/${mode}?id=${mode === 'client' ? clientId : locationId}`)
      .then(x => {
        this.setState({users: x.data, loading: false});
      });
  }

  render() {
    let {user, mode, clientId, locationId} = this.props;

    return (<div style={{marginBottom: '25px'}}>
      <div className="row">
        <div className="col-md-12">
          <h5>Users with access</h5>
          {this.state.loading ?
            <h6>Loading...</h6> :
            <ReactTable
              sortable={false}
              filterable={false}
              showPagination={false}
              data={this.state.users}
              columns={UserCols(this.props, this.state)}
              defaultPageSize={100}
              minRows={2}
              style={{marginBottom: '25px'}}
            />}
        </div>
      </div>
    </div>);
  }
}

UsersByClientLocationControl.propTypes = {
  locationId: PropTypes.number,
  clientId: PropTypes.number,
  mode: PropTypes.oneOf(['location', 'client']),
  onSelectUser: PropTypes.func.isRequired,
};

export default UsersByClientLocationControl;
